// extracted by mini-css-extract-plugin
export default {"container":"VX-z","title":"WX-z","link":"XX-z"};